import React, { useCallback } from 'react';
import { Dropdown } from '@shootsta/common-react';
import InformationStepsList from './InformationStepsList';
import { INFORMATION_STEPS_LIST } from '../constants/informationStepsList';
import '../styles/_information-steps.scss';

export default function InformationSteps() {
  const onSelectInformationStep = useCallback((currentInformationStep) => {
    window.open(currentInformationStep.link, '_blank');
  }, []);

  return (
    <div className="information-steps">
      <Dropdown
        className="information-steps__dropdown"
        options={INFORMATION_STEPS_LIST}
        defaultValue="Quick Actions"
        onChange={onSelectInformationStep}
        type="BUTTON"
      />

      <InformationStepsList onSelectInformationStep={onSelectInformationStep} />
    </div>
  );
}
